import { type GooglePlacesAddress } from "utils/google-places/address";

export function addressIsComplete(googlePlacesAddress: GooglePlacesAddress) {
  return (
    !!googlePlacesAddress &&
    !!googlePlacesAddress.city &&
    !!googlePlacesAddress.postalCode &&
    !!googlePlacesAddress.stateCode &&
    !!googlePlacesAddress.street &&
    !!googlePlacesAddress.streetNumber
  );
}
